import React from "react";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function CTASection() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      style={{ marginTop: "60px", marginBottom: "50px" }}
    >
      <MKBox
        component="section"
        py={{ xs: 6, md: 10 }}
        px={{ xs: 3, md: 8 }}
        sx={{
          background: "#ffffff", // PURE WHITE
          borderRadius: "2rem",
          boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
          border: "1px solid rgba(0,0,0,0.05)",

          color: "#1F2937", // dark text for contrast
          overflow: "hidden",
          position: "relative",
        }}
      >
        {/* Optional floating gradient shapes */}
        <MKBox
          sx={{
            position: "absolute",
            width: "250px",
            height: "250px",
            borderRadius: "50%",
            background: "radial-gradient(circle at 30% 30%, #FF416C, #1FA2FF)",
            top: "-50px",
            left: "-50px",
            opacity: 0.3,
            filter: "blur(60px)",
            zIndex: 0,
          }}
        />
        <MKBox
          sx={{
            position: "absolute",
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            background: "radial-gradient(circle at 70% 70%, #00F260, #0575E6)",
            bottom: "-50px",
            right: "-50px",
            opacity: 0.3,
            filter: "blur(50px)",
            zIndex: 0,
          }}
        />

        <Grid container spacing={3} alignItems="center" sx={{ position: "relative", zIndex: 1 }}>
          <Grid item xs={12} md={4} lg={5} sx={{ textAlign: { xs: "center", md: "center" } }}>
            <Link to="/services/booking" style={{ textDecoration: "none" }}>
              <MKButton
                variant="gradient"
                color="white"
                size="large"
                sx={{
                  borderRadius: "2rem",
                  px: 6,
                  py: 1.8,
                  fontWeight: "bold",
                  textTransform: "capitalize",
                  color: "#1F2937",
                  fontSize: { xs: "1rem", md: "1.1rem" },
                  background: "linear-gradient(135deg, #FF416C, #1FA2FF)",
                  boxShadow: "0 8px 20px rgba(255,255,255,0.3)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-3px) scale(1.05)",
                    boxShadow: "0 12px 40px rgba(255,255,255,0.4)",
                  },
                }}
              >
                Book Now
              </MKButton>
            </Link>
          </Grid>

          <Grid item xs={12} md={8} lg={7}>
            <MKTypography
              variant="h5"
              fontWeight="bold"
              sx={{
                lineHeight: 1.4,
                textAlign: { xs: "center", md: "right" },
                fontSize: { xs: "1.1rem", md: "1.3rem" },
              }}
            >
              Avoid unnecessary stress and uncertainty — we are here to support you in making your
              stay smooth, enjoyable, and free from unpleasant surprises.
            </MKTypography>
          </Grid>
        </Grid>
      </MKBox>
    </motion.div>
  );
}

export default CTASection;
